


import { getStandardReturnDetails, StandardReturnDetailsResult } from "@dana/Services/StandardReturnDetailsService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, HasOnError } from "@insite/client-framework/HandlerCreator";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";


type HandlerType = ApiHandlerDiscreteParameter<
    GetOrderApiParameter
    & HasOnError<string>,
    GetOrderApiParameter,
    StandardReturnDetailsResult
>;
export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsOrerDetails/Init",
        isLoading: true,
    } as any);
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        orderNumber: props.parameter.orderNumber,
        expand: ["orderLines"],
        additionalExpands: props.parameter.additionalExpands
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getStandardReturnDetails(props.apiParameter);
    } catch (error) {
        if (error.status === 404 || error.status === 403) {
            props.parameter.onError?.(error.errorMessage);
            return;
        }
        throw error;
    }
};
export const LoadCreditMemoDetailsResponse: HandlerType = props => {
    props.dispatch({
        type: "StandardReturnsOrerDetails/LoadData",
        logo: props.apiResult?.logo,
        orderModel: props.apiResult?.standardReturnOrderDetails,
        rmaAdditionalDetails: props.apiResult?.rmaAdditionalDetails,
        salseOrgDetails: props.apiResult?.salseOrgDetails,
        dispositionPreferences: props.apiResult?.dispositionPreferences
    } as any);

    props.dispatch({
        type: "StandardReturnsOrerDetails/IsLoading",
        isLoading: false,
    } as any);
};

export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, LoadCreditMemoDetailsResponse];

const getStandardReturnOrderDetails = createHandlerChainRunner(chain, "StandardReturnOrderDetailsHandler");
export default getStandardReturnOrderDetails;